/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import controlIcons from '../../../constants/icons';

export const BTN_WIDTH_TYPES = [
    { label: __('Auto', 'afftra-blocks'), value: 'auto' },
    { label: __('Full', 'afftra-blocks'), value: 'full' },
    { label: __('Custom', 'afftra-blocks'), value: 'custom' }
];

export const DIRECTIONS = [
    { label: __('Horizontal', 'afftra-blocks'), value: 'row', icon: controlIcons['row'] },
    { label: __('Vertical', 'afftra-blocks'), value: 'column', icon: controlIcons['column'] }
];

// galobal section
export const IMAX_WIDTH = 'iMaxWidth';
export const G_TYPO = 'gTypo';
export const GL_GAP = 'gGap';
export const N_TYPO = 'nTypo';
export const G_MARGIN = 'gMargin';
export const S_HEIGHT = 'sHeight';
export const T_TYPO = 'tTypo';
export const NU_TYPO = 'nuTypo';
export const F_BG = 'fBg';
export const B_BG = 'bBg';
export const G_RADIUS = 'gRadius';
export const FG_RADIUS = 'fgRadius';

// Item
export const ITEM_ALIGN = 'itemAlign';
// rating
export const RATING_SIZE = 'ratingSize';
// numeric rating
export const NR_TYPO = 'nrTypo';
export const NR_GAP = 'nrGap';
// title
export const TITLE_TYPO = 'titleTypo';
export const TITLE_GAP = 'titleGap';
